import { ApiRequest, ApiResponse } from '@shared/extension/interfaces/api-request.interface';
import { Observable } from 'rxjs';

export abstract class AbstractApiRequestService {
  abstract getAppSyncQueryData<T = unknown>(
    query: string,
    variables?: { [key: string]: unknown },
    cacheResponse?: boolean,
  ): Promise<T>;
  abstract getApiRequestData<T = unknown>(
    request: ApiRequest,
    cacheResponse?: boolean,
  ): Promise<T>;
  abstract sendAppSyncQuery<T = unknown, E = unknown>(
    query: string,
    variables?: { [key: string]: unknown },
    cacheResponse?: boolean,
  ): Promise<ApiResponse<T, E>>;
  abstract sendApiRequest<T = unknown, E = unknown>(
    request: ApiRequest,
    cacheResponse?: boolean,
  ): Promise<ApiResponse<T, E>>;
  abstract subscribe<T = unknown>(
    query: string,
    variables?: { [key: string]: unknown },
  ): Observable<T>;
}
